/**
 * @author fengpan
 */

/**
 * 使api url function 化
 *
 * e.g
 *
 *  @src/config/apiMap = {
 *      pathA: '/api/post/code',
 *      pathB: '/api/post/auth'
 *  }
 *
 *  apify(api).pathA({
 *                  method: 'get',
 *                  data:{
 *                      a:123
 *                  }
 *              })
 *      .then()
 *      .catch();
 * 
 */

import _ from 'lodash';
import apify from './apify';
import apiMap from '@/config/apiMap';
import './interceptor';

let api: {
    key: string;
    path: string;
    origin: string
}[] = apiMap;

export default apify(api);
